import React from "react";

const RELOAD_KEY = "app_chunk_reload_count";
const MAX_RELOAD = 3;

const generateErrorId = () => {
    try {
        return crypto.randomUUID();
    } catch {
        return `${Date.now()}-${Math.random().toString(36).substring(2, 8)}`;
    }
};

const ErrorPage = ({
    error,
    resetErrorBoundary
}: any) => {
    const errorId = React.useMemo(() => generateErrorId(), []);

    const handleRefresh = () => {
        sessionStorage.removeItem(RELOAD_KEY);
        window.location.reload();
    };

    const handleHome = () => {
        sessionStorage.removeItem(RELOAD_KEY);
        window.location.href = "/";
    };
    return (
        <div
            style={{
                maxWidth: 650,
                margin: "40px auto",
                padding: "24px",
                textAlign: "center",
                border: "1px solid #e5e5e5",
                borderRadius: 10,
                background: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,.08)",
            }}
        >
            <div
                style={{
                    fontSize: 42,
                    marginBottom: 10,
                }}
            >
                ⚠️
            </div>

            <h2 style={{ marginBottom: 10 }}>
                Something went wrong
            </h2>

            <p
                style={{
                    color: "#666",
                    marginBottom: 15,
                    lineHeight: 1.5,
                }}
            >
                We couldn't complete your request.
                <br />
                This may be due to an application update, browser cache, or a temporary issue.
            </p>

            <div
                style={{
                    background: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    borderRadius: 6,
                    padding: "10px 15px",
                    marginBottom: 20,
                    fontSize: 14,
                }}
            >
                <strong>Error Reference:</strong> {errorId}
            </div>

            {(process.env.REACT_APP_ENV === "dev" || process.env.REACT_APP_ENV === "qa") && (
                <details
                    style={{
                        textAlign: "left",
                        marginBottom: 20,
                    }}
                >
                    <summary
                        style={{
                            cursor: "pointer",
                            fontWeight: 600,
                        }}
                    >
                        Technical Details
                    </summary>

                    <pre
                        style={{
                            marginTop: 10,
                            maxHeight: 160,
                            overflow: "auto",
                            background: "#f5f5f5",
                            padding: 10,
                            borderRadius: 5,
                            fontSize: 12,
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        {error.message}

                        {"\n\n"}

                        {error.stack}
                    </pre>
                </details>
            )}

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 10,
                    flexWrap: "wrap",
                }}
            >
                <button
                    className="btn btn-primary"
                    onClick={handleRefresh}
                >
                    Refresh Page
                </button>

                <button
                    className="btn btn-outline-primary"
                    onClick={resetErrorBoundary}
                >
                    Try Again
                </button>

                <button
                    className="btn btn-outline-secondary"
                    onClick={handleHome}
                >
                    Go Home
                </button>
            </div>
        </div>
    );
}
export default ErrorPage;